import 'css-chunksrc/client/pages/projectPage/exportsPage/timesheetByTaskReport/filters/styles.scss';export default {
  "filters": "_filters_x3w5s_1",
  "resetButton": "_resetButton_x3w5s_17",
  "label": "_label_x3w5s_25",
  "section": "_section_x3w5s_32"
};